import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {
    IMPGalleryModule,
    IMPGallerySubItemModule
} from "../marketing-page.models";
import {LoggerService} from "../../common/logger.service";
import {MarketingPageUtil} from "../marketing-page-util";
import {TranslateService} from "../../translation/translate.service";

@Component({
    templateUrl: './gallery.component.html',
    styleUrls: ['./gallery.component.scss'],
    standalone: false
})
export class GalleryComponent extends UsanaObject implements OnInit  {

    pageUrl: string;
    componentData: IMPGalleryModule;
    useLocaleOverride: boolean;
    translationRoot: string;

    textStyle: string;
    backgroundColor: string;
    galleryItems: IMPGallerySubItemModule[] = [];
    galleryTitle: string;


    constructor(
        loggerService: LoggerService,
        private translationService: TranslateService
    ){
        super(
            loggerService
        );
    }

    ngOnInit() {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        this.textStyle = MarketingPageUtil.getTextStyleClass(this.componentData.textStyle);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.galleryItems = this.componentData.children;
        this.translationService.translate(this.translationRoot + '.title', this.useLocaleOverride).then((translation: string) => {
            if (translation.trim().length > 0) {
                this.galleryTitle = translation;
            }
        });
    }
}
